import React from 'react';
import { Row, Col, Collapse, BackTop } from 'antd';
import { ArrowUpOutlined } from '@ant-design/icons';

import { images } from '@assets/img';
import ImageComponent from '@sharedComponent/image-component';

const { Panel } = Collapse;

const TermsAndConditionsPresentational = ({ terms, history, fromDashboard }) => {
	const termsList = fromDashboard ? terms.slice(0, 4) : terms;
	return (
		<Row className="termsContainer" align="top" justify={'center'}>
			{!fromDashboard && (
				<Col xl={24} className="header">
					<Row align={'middle'} justify="space-around">
						<Col xl={6} md={24} sm={24} xs={24} className="imgContainer" onClick={() => history.goBack()}>
							<ImageComponent src={images.konnektivelogo} />
						</Col>
						<Col xl={12} md={24} sm={24} xs={24} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
							<span>Terms and Conditions</span>
						</Col>
						<Col xl={6} md={24} sm={24} xs={24} />
					</Row>
				</Col>
			)}
			<Col xl={fromDashboard ? 24 : 22}>
				<p className="titleParagraph">
					This is your Affiliate Agreement (“Agreement”) with Konnektive LLC (also d/b/a FunnelKonnekt), a Puerto Rico Limited Liability
					Company with a principal place of business at 2421 Laurel St., San Juan, Puerto Rico 00913 (“Konnektive”). This Agreement is a
					legal and enforceable agreement that governs your relationship with Konnektive once you scroll to the end of this Agreement and
					accept its terms and conditions by checking the “I Have Read and Accept the Terms and Conditions of this Agreement” box and
					clicking the Submit button.
				</p>
			</Col>
			<Col xl={24} md={24} sm={24} xs={24} className="contentArea">
				<Row justify="center">
					<Col xl={fromDashboard ? 22 : 18} lg={18} md={12} sm={24} xs={24}>
						<Col xl={24}>
							<Collapse
								accordion={false}
								defaultActiveKey={fromDashboard ? [] : ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13']}>
								{termsList.map((term, i) => (
									<Panel header={`${i + 1}. ${term.title}`} key={i} className="site-collapse-custom-panel">
										{term.content.map((data, childIndex) => (
											<Row className="childStyle">
												{term.content.length > 1 && (
													<Col>
														<span className="childIndex">{`${i + 1}.${childIndex + 1}`}</span>
														<span className="childIndex">{`${data.title}`}</span>
													</Col>
												)}
												<Col xl={24}>
													<p>{data.text}</p>
												</Col>
											</Row>
										))}
									</Panel>
								))}
							</Collapse>
						</Col>
					</Col>
				</Row>
			</Col>
			<BackTop>
				<div className="backStyle">
					<ArrowUpOutlined />
				</div>
			</BackTop>
			{!fromDashboard && (
				<Col className="backPage" xl={24} onClick={() => history.goBack()}>
					<span>Back to Register</span>
				</Col>
			)}
		</Row>
	);
};

export default TermsAndConditionsPresentational;
